import { IFin } from "../../fin/IFin";
import { IWykrojnikRow } from "../IWykrojnikRow";
import { ILicz, Licz,Wartość } from "./Log";

export class OfertaCell {

  public static calc(fin:IFin, koszt_transportu:number, w:IWykrojnikRow, przezbrojen:number, naklad:number, zmian:number, narzut_zysku_procent:number, licz_w_pln:boolean) {
    const expl:Licz = OfertaCell.get_price(narzut_zysku_procent, naklad, zmian, fin, koszt_transportu, w, licz_w_pln) 
    return expl.get_x();
  }



  public static get_price(narzut:number, naklad:number, zmian:number, fin:IFin, koszt_transportu:number, w:IWykrojnikRow, licz_w_pln:boolean) {
    
    const przezbrojen = 1
    const n:number = 1+(narzut/100); 
    const n_ =  new Wartość("narzut",n)

    let koszt_przezbr =  (fin.faktor_mh_przezbr/100) * w.koszt_przezbr.koszt_rob  + w.koszt_przezbr.koszt_sur * przezbrojen;
    koszt_przezbr *=n;
    const faktor_mh_przezbr_ =  new Wartość("faktor_mh_przezbr",fin.faktor_mh_przezbr)
    const koszt_sur_przezbr_ =  new Wartość("koszt_sur_przezbr",w.koszt_przezbr.koszt_sur)
    const koszt_rob_przezbr_ =  new Wartość("koszt_rob_przezbr",w.koszt_przezbr.koszt_rob)
    const przezbrojen_ =  new Wartość("przezbrojen",przezbrojen)
    const koszt_przezbr_ =  new Licz("koszt_przezbr =  ( narzut*(faktor_mh_przezbr/100) * koszt_rob_przezbr)  + koszt_sur_przezbr )  * przezbrojen")
    koszt_przezbr_.add_det(n_)
    koszt_przezbr_.add_det(faktor_mh_przezbr_)
    koszt_przezbr_.add_det(koszt_sur_przezbr_)
    koszt_przezbr_.add_det(koszt_rob_przezbr_)
    koszt_przezbr_.add_det(przezbrojen_)
    koszt_przezbr_.set_x(koszt_przezbr)

    
    const faktor_mh_praca_ =  new Wartość("faktor_mh_praca",fin.faktor_mh_praca)
    let koszt_sur_1K_:ILicz=new Wartość("koszt_sur_1K ZERO",0);
    koszt_sur_1K_=  new Wartość("koszt_sur_1K",w.koszt_1K.koszt_sur)
/*
    Example: Licz przekazywany do OfertaCell 
    if (w.koszt_1K.licz) {
      koszt_sur_1K_=new Wartość("koszt_sur_1K w.koszt_1K.licz defined",0);
      const k1k = Licz.get_det(w.koszt_1K.licz,"koszt_surowcow_1K = mb_druku_nominalne_1K * straty_surowca_faktor * koszt_surowcow_za_mb + mb_druku_nominalne_1K_newfoil * straty_surowca_faktor * koszt_surowcow_za_mb_newfoil ")
      if (k1k) {
        koszt_sur_1K_ =  k1k
      }
    }
    */


    const koszt_rob_1K_bez_min_ =  new Wartość("koszt_rob_1K_bez_min",w.koszt_1K.koszt_rob)
    const min_koszt_rob_stara_kalk_ = new Wartość("min_koszt_rob_stara_kalk",w.koszt_1K.min_koszt_rob);

    let koszt_rob_1K = w.koszt_1K.koszt_rob;
    if (w.koszt_1K.min_koszt_rob && w.koszt_1K.koszt_rob*naklad < w.koszt_1K.min_koszt_rob) { 
      koszt_rob_1K=w.koszt_1K.min_koszt_rob/naklad;
    }
    const koszt_rob_1K_ =  new Wartość("koszt_rob_1K_",koszt_rob_1K)
    let koszt_druku   = ((fin.faktor_mh_praca  /100) * koszt_rob_1K       + w.koszt_1K.koszt_sur)   * naklad;
    koszt_druku *=n;
    
    const naklad_ =  new Wartość("naklad",naklad)
    const koszt_druku_ =  new Licz("koszt_druku = narzut* ( (faktor_mh_praca/100) * koszt_rob_1K  + koszt_sur_1K )  * naklad")
    koszt_druku_.add_det(n_)
    koszt_druku_.add_det(faktor_mh_praca_)
    koszt_druku_.add_det(koszt_sur_1K_)
    koszt_druku_.add_det(koszt_rob_1K_)
    koszt_druku_.add_det(naklad_)
    koszt_druku_.set_x(koszt_druku)

    let koszt_zmian   =  ((fin.faktor_mh_aw     /100) * w.koszt_zmiany.koszt_rob   + w.koszt_zmiany.koszt_sur  )  * zmian 
    koszt_zmian *=n;
    const faktor_mh_aw_ =  new Wartość("faktor_mh_aw",fin.faktor_mh_aw)
    const koszt_sur_zmiany_ =  new Wartość("koszt_sur_zmiany",w.koszt_zmiany.koszt_sur)
    const koszt_rob_zmiany_ =  new Wartość("koszt_rob_zmiany",w.koszt_zmiany.koszt_rob)
    const zmian_ =  new Wartość("zmian",zmian)
    const koszt_zmian_ =  new Licz("koszt_zmian = narzut* ( (faktor_mh_aw/100) * koszt_rob_zmiany  + koszt_sur_zmiany )  * zmian")
    koszt_zmian_.add_det(n_)
    koszt_zmian_.add_det(faktor_mh_aw_)
    koszt_zmian_.add_det(koszt_sur_zmiany_)
    koszt_zmian_.add_det(koszt_rob_zmiany_)
    koszt_zmian_.add_det(zmian_)
    koszt_zmian_.set_x(koszt_zmian)

    const koszt_produkcji_EUR_ =  new Licz("koszt_produkcji_EUR = koszt_przezbr + koszt_druku + koszt_zmian")
    koszt_produkcji_EUR_.add_det(koszt_przezbr_)
    koszt_produkcji_EUR_.add_det(koszt_druku_)
    koszt_produkcji_EUR_.add_det(koszt_zmian_)
    koszt_produkcji_EUR_.set_x(koszt_przezbr_.get_x() + koszt_druku_.get_x() + koszt_zmian_.get_x()  )

    let dodaj_koszt_transportu=0;
    let faktor_koszt_transportu=1.0;
    if (fin.warunki_dostawy.indexOf("EXW")==-1)    {
      if (koszt_transportu) {
        dodaj_koszt_transportu=koszt_transportu
        faktor_koszt_transportu = 1.0
      } else {
        dodaj_koszt_transportu  = 0
        faktor_koszt_transportu = 1.0;
        if (fin.warunki_dostawy.indexOf("EXW")==-1) faktor_koszt_transportu = 1.0105;
      }
    }
    const dodaj_koszt_transportu_ =  new Wartość("dodaj_koszt_transportu",dodaj_koszt_transportu)
    const faktor_koszt_transportu_ =  new Wartość("faktor_koszt_transportu",faktor_koszt_transportu)
    const dodajKosztProcent_ =  new Wartość("dodajKosztProcent",fin.dodajKosztProcent)
    const rabatProcent_ =  new Wartość("rabatProcent",fin.rabatProcent)
    const dodajKoszt1K_ =  new Wartość("dodajKoszt1K",fin.dodajKoszt1K)
    

    let kurs=1.0
    if (!(fin.waluta_kalkulacji=="EUR") || licz_w_pln) kurs=fin.kurs_euro;
    const kurs_ =  new Wartość("kurs",kurs)

    const koszt = (((koszt_produkcji_EUR_.get_x()+dodaj_koszt_transportu) * faktor_koszt_transportu * ( 1+fin.dodajKosztProcent/100  )* ( 1-fin.rabatProcent/100 ))/naklad +   fin.dodajKoszt1K)*kurs
    const koszt_ = new Licz("koszt_1K = (((koszt_produkcji_EUR+dodaj_koszt_transportu) * faktor_koszt_transportu  * ( 1+dodajKosztProcent/100  ) * ( 1-rabatProcent/100 ) +   dodajKoszt1K))/nakład * kurs")
    koszt_.add_det(koszt_produkcji_EUR_)
    koszt_.add_det(dodaj_koszt_transportu_)
    koszt_.add_det(faktor_koszt_transportu_)
    koszt_.add_det(dodajKosztProcent_)
    koszt_.add_det(rabatProcent_)
    koszt_.add_det( new Wartość("nakład",naklad))
    koszt_.add_det(dodajKoszt1K_)
    koszt_.add_det(kurs_)
    koszt_.set_x(koszt)

    const koszt_finalny_ = new Licz("koszt_finalny 1K = max( koszt_1K, cena_min_1K)")
    koszt_finalny_.add_det(koszt_)
    koszt_finalny_.set_x(koszt)
    
    if (fin.cena_min_za_naklad) {
      const cena_min_za_naklad_:Licz = <Licz>fin.cena_min_za_naklad;
      const cena_min_1K_ = new Licz("cena_min_1K = cena_min_za_naklad*kurs/naklad")
      cena_min_1K_.add_det(cena_min_za_naklad_)
      cena_min_1K_.add_det(kurs_)
      cena_min_1K_.add_det(new Wartość("nakład",naklad))
      let min_koszt:number =  (<number>(<any>cena_min_za_naklad_).x);
      min_koszt *=kurs
      min_koszt/=naklad
      cena_min_1K_.set_x(min_koszt)

      koszt_finalny_.add_det(cena_min_1K_);
      if (min_koszt && koszt<min_koszt) {
        koszt_finalny_.set_x(min_koszt)
      }
    }

    let koszt_sur_txt=""
    koszt_sur_txt   += "koszt_sur_przezbr * przezbrojen "
    koszt_sur_txt   += "+ koszt_sur_1K * naklad "
    koszt_sur_txt   += "+ koszt_sur_zmiany * zmian "
    let koszt_sur = 0
    koszt_sur       += w.koszt_przezbr.koszt_sur * przezbrojen;
    koszt_sur       += w.koszt_1K.koszt_sur * naklad;
    koszt_sur       += w.koszt_zmiany.koszt_sur * zmian;
    const koszt_produkcji_surowiec_EUR_= new Licz("koszt_produkcji_surowiec_EUR = "+koszt_sur_txt);
    koszt_produkcji_surowiec_EUR_.add_det(koszt_sur_przezbr_)
    koszt_produkcji_surowiec_EUR_.add_det(przezbrojen_)
    koszt_produkcji_surowiec_EUR_.add_det(koszt_sur_1K_)
    koszt_produkcji_surowiec_EUR_.add_det(naklad_)
    koszt_produkcji_surowiec_EUR_.add_det(koszt_sur_zmiany_)
    koszt_produkcji_surowiec_EUR_.add_det(zmian_)
    koszt_produkcji_surowiec_EUR_.add_det(new Wartość("nakład",naklad))
    koszt_produkcji_surowiec_EUR_.set_x(koszt_sur);

    let koszt_rob = 0
    let koszt_rob_txt=""
    koszt_rob_txt   += "(faktor_mh_przezbr/100) * koszt_rob_przezbr * przezbrojen "
    koszt_rob_txt   += "+ [(faktor_mh_praca/100) * koszt_rob_1K * naklad] "
    koszt_rob_txt   += "+ [(faktor_mh_aw/100) * koszt_rob_zmiany * zmian] "
    koszt_rob += (fin.faktor_mh_przezbr/100) * w.koszt_przezbr.koszt_rob * przezbrojen
    koszt_rob += (fin.faktor_mh_praca  /100) * koszt_rob_1K *naklad
    koszt_rob += (fin.faktor_mh_aw     /100) * w.koszt_zmiany.koszt_rob * zmian;
    const koszt_produkcji_rob_EUR_= new Licz("koszt_produkcji_robocizna_EUR = "+koszt_rob_txt);
    koszt_produkcji_rob_EUR_.set_x(koszt_rob);
    koszt_produkcji_rob_EUR_.add_det(faktor_mh_przezbr_)
    koszt_produkcji_rob_EUR_.add_det(koszt_rob_przezbr_)
    koszt_produkcji_rob_EUR_.add_det(przezbrojen_)
    koszt_produkcji_rob_EUR_.add_det(faktor_mh_praca_)
    koszt_produkcji_rob_EUR_.add_det(koszt_rob_1K_)
    koszt_produkcji_rob_EUR_.add_det(naklad_)
    koszt_produkcji_rob_EUR_.add_det(koszt_rob_1K_)
    koszt_produkcji_rob_EUR_.add_det(faktor_mh_aw_)
    koszt_produkcji_rob_EUR_.add_det(koszt_rob_zmiany_)
    koszt_produkcji_rob_EUR_.add_det(zmian_)


    const koszt_produkcji_netto_ = new Wartość("koszt_produkcji_netto",koszt_produkcji_rob_EUR_.get_x() + koszt_produkcji_surowiec_EUR_.get_x())
    
    const koszt_finalny_EUR_ = new Licz("koszt_finalny EUR = (koszt_finalny 1K/kurs) * naklad")
    koszt_finalny_EUR_.add_det(koszt_finalny_)
    koszt_finalny_EUR_.add_det(kurs_)
    koszt_finalny_EUR_.add_det( new Wartość("nakład",naklad))
    koszt_finalny_EUR_.set_x(0)
    if (kurs_?.get_x() && koszt_finalny_?.get_x()) {
      koszt_finalny_EUR_.set_x(koszt_finalny_.get_x()/kurs_.get_x()*naklad)
    }
    const udzial_kosztu_sur_ = new Licz("udział_kosztu_sur% = 100% * (koszt_produkcji_surowiec_EUR / koszt_finalny_1K_EUR)")
    udzial_kosztu_sur_.add_det(koszt_produkcji_surowiec_EUR_)
    udzial_kosztu_sur_.add_det(koszt_finalny_EUR_)
    
    if (koszt_produkcji_EUR_.get_x()) {
      udzial_kosztu_sur_.set_x(100 * Math.round((koszt_produkcji_surowiec_EUR_.get_x()/koszt_finalny_EUR_.get_x())*1000)/1000);
    } else {
      udzial_kosztu_sur_.set_x(0);
    }


  

    koszt_.add_det(koszt_produkcji_netto_);
    //koszt_.add_det(koszt_produkcji_surowiec_EUR_)
    
    


    //koszt_.add_det(koszt_produkcji_EUR_)
    koszt_.add_det(dodaj_koszt_transportu_)
    
    koszt_finalny_.add_det(udzial_kosztu_sur_)
    
    return koszt_finalny_;

  }

  public static get_narzut(koszt_manualny:number, narzut_auto: number, naklad:number, zmian:number, fin:IFin, koszt_transportu:number, w:IWykrojnikRow, licz_w_pln:boolean):Licz {
  
    const przezbrojen = 1
    const n:number = 1+(narzut_auto/100); 
    const n_ =  new Wartość("narzut",n)

    const koszt_przezbr =  n* (fin.faktor_mh_przezbr/100) * ( w.koszt_przezbr.koszt_rob  + w.koszt_przezbr.koszt_sur )  * przezbrojen;
    const faktor_mh_przezbr_ =  new Wartość("faktor_mh_przezbr",fin.faktor_mh_przezbr)
    const koszt_sur_przezbr_ =  new Wartość("koszt_sur_przezbr",w.koszt_przezbr.koszt_sur)
    const koszt_rob_przezbr_ =  new Wartość("koszt_rob_przezbr",w.koszt_przezbr.koszt_rob)
    const przezbrojen_ =  new Wartość("przezbrojen",przezbrojen)
    const koszt_przezbr_ =  new Licz("koszt_przezbr =  ( narzut*(faktor_mh_przezbr/100) * koszt_rob_przezbr)  + koszt_sur_przezbr )  * przezbrojen")
    koszt_przezbr_.add_det(n_)
    koszt_przezbr_.add_det(faktor_mh_przezbr_)
    koszt_przezbr_.add_det(koszt_sur_przezbr_)
    koszt_przezbr_.add_det(koszt_rob_przezbr_)
    koszt_przezbr_.add_det(przezbrojen_)
    koszt_przezbr_.set_x(koszt_przezbr)

    
    const faktor_mh_praca_ =  new Wartość("faktor_mh_praca",fin.faktor_mh_praca)
    const koszt_sur_1K_ =  new Wartość("koszt_sur_1K",w.koszt_1K.koszt_sur)
    const koszt_rob_1K_bez_min_ =  new Wartość("koszt_rob_1K_bez_min",w.koszt_1K.koszt_rob)
    const min_koszt_rob_stara_kalk_ = new Wartość("min_koszt_rob_stara_kalk",w.koszt_1K.min_koszt_rob);

    let koszt_rob_1K = w.koszt_1K.koszt_rob;
    if (w.koszt_1K.min_koszt_rob && w.koszt_1K.koszt_rob*naklad < w.koszt_1K.min_koszt_rob) { 
      koszt_rob_1K=w.koszt_1K.min_koszt_rob/naklad;
    }
    const koszt_rob_1K_ =  new Wartość("koszt_rob_1K_",koszt_rob_1K)
    const koszt_druku   = n*  (fin.faktor_mh_praca  /100) * (koszt_rob_1K  + w.koszt_1K.koszt_sur)  * naklad;

    
    const naklad_ =  new Wartość("naklad",naklad)
    const koszt_druku_ =  new Licz("koszt_druku = narzut* ( (faktor_mh_praca/100) * koszt_rob_1K  + koszt_sur_1K )  * naklad")
    koszt_druku_.add_det(n_)
    koszt_druku_.add_det(faktor_mh_praca_)
    koszt_druku_.add_det(koszt_sur_1K_)
    koszt_druku_.add_det(koszt_rob_1K_)
    koszt_druku_.add_det(naklad_)
    koszt_druku_.set_x(koszt_druku)

    const koszt_zmian   = n*  (fin.faktor_mh_aw /100) * (w.koszt_zmiany.koszt_rob   + w.koszt_zmiany.koszt_sur )  * zmian 
    const faktor_mh_aw_ =  new Wartość("faktor_mh_aw",fin.faktor_mh_aw)
    const koszt_sur_zmiany_ =  new Wartość("koszt_sur_zmiany",w.koszt_zmiany.koszt_sur)
    const koszt_rob_zmiany_ =  new Wartość("koszt_rob_zmiany",w.koszt_zmiany.koszt_rob)
    const zmian_ =  new Wartość("zmian",zmian)
    const koszt_zmian_ =  new Licz("koszt_zmian = narzut* ( (faktor_mh_aw/100) * koszt_rob_zmiany  + koszt_sur_zmiany )  * zmian")
    koszt_zmian_.add_det(n_)
    koszt_zmian_.add_det(faktor_mh_aw_)
    koszt_zmian_.add_det(koszt_sur_zmiany_)
    koszt_zmian_.add_det(koszt_rob_zmiany_)
    koszt_zmian_.add_det(zmian_)
    koszt_zmian_.set_x(koszt_zmian)

    const koszt_produkcji_EUR_ =  new Licz("koszt_produkcji_EUR = koszt_przezbr + koszt_druku + koszt_zmian")
    koszt_produkcji_EUR_.add_det(koszt_przezbr_)
    koszt_produkcji_EUR_.add_det(koszt_druku_)
    koszt_produkcji_EUR_.add_det(koszt_zmian_)
    koszt_produkcji_EUR_.set_x(koszt_przezbr_.get_x() + koszt_druku_.get_x() + koszt_zmian_.get_x()  )

    let dodaj_koszt_transportu=0;
    let faktor_koszt_transportu=1.0;
    if (fin.warunki_dostawy.indexOf("EXW")==-1)    {
      if (koszt_transportu) {
        dodaj_koszt_transportu=koszt_transportu
        faktor_koszt_transportu = 1.0
      } else {
        dodaj_koszt_transportu  = 0
        faktor_koszt_transportu = 1.0;
        if (fin.warunki_dostawy.indexOf("EXW")==-1) faktor_koszt_transportu = 1.0105;
      }
    }
    const dodaj_koszt_transportu_ =  new Wartość("dodaj_koszt_transportu",dodaj_koszt_transportu)
    const faktor_koszt_transportu_ =  new Wartość("faktor_koszt_transportu",faktor_koszt_transportu)
    const dodajKosztProcent_ =  new Wartość("dodajKosztProcent",fin.dodajKosztProcent)
    const rabatProcent_ =  new Wartość("rabatProcent",fin.rabatProcent)
    const dodajKoszt1K_ =  new Wartość("dodajKoszt1K",fin.dodajKoszt1K)
    

    let kurs=1.0
    if (!(fin.waluta_kalkulacji=="EUR") || licz_w_pln) kurs=fin.kurs_euro;
    const kurs_ =  new Wartość("kurs",kurs)

    const koszt = (((koszt_produkcji_EUR_.get_x()+dodaj_koszt_transportu) * faktor_koszt_transportu * ( 1+fin.dodajKosztProcent/100  )* ( 1-fin.rabatProcent/100 ))/naklad +   fin.dodajKoszt1K)*kurs
    const koszt_ = new Licz("koszt = (((koszt_produkcji_EUR dodaj_koszt_transportu) * faktor_koszt_transportu  * ( 1+dodajKosztProcent/100  ) * ( 1-rabatProcent/100 ) +   dodajKoszt1K))/nakład * kurs")
    koszt_.add_det(koszt_produkcji_EUR_)
    koszt_.add_det(dodaj_koszt_transportu_)
    koszt_.add_det(faktor_koszt_transportu_)
    koszt_.add_det(dodajKosztProcent_)
    koszt_.add_det(rabatProcent_)
    koszt_.add_det( new Wartość("nakład",naklad))
    koszt_.add_det(dodajKoszt1K_)
    koszt_.add_det(kurs_)
  
    let koszt_sur_txt=""
    koszt_sur_txt   += "koszt_sur_przezbr * przezbrojen "
    koszt_sur_txt   += "+ koszt_sur_1K * naklad "
    koszt_sur_txt   += "+ koszt_sur_zmiany * zmian "
    let koszt_sur = 0
    koszt_sur       += w.koszt_przezbr.koszt_sur * przezbrojen;
    koszt_sur       += w.koszt_1K.koszt_sur * naklad;
    koszt_sur       += w.koszt_zmiany.koszt_sur * zmian;
    const koszt_produkcji_surowiec_EUR_= new Licz("koszt_produkcji_surowiec_EUR = "+koszt_sur_txt);
    koszt_produkcji_surowiec_EUR_.add_det(koszt_sur_przezbr_)
    koszt_produkcji_surowiec_EUR_.add_det(przezbrojen_)
    koszt_produkcji_surowiec_EUR_.add_det(koszt_sur_1K_)
    koszt_produkcji_surowiec_EUR_.add_det(naklad_)
    koszt_produkcji_surowiec_EUR_.add_det(koszt_sur_zmiany_)
    koszt_produkcji_surowiec_EUR_.add_det(zmian_)
    koszt_produkcji_surowiec_EUR_.set_x(koszt_sur);

    let koszt_rob = 0
    let koszt_rob_txt=""
    koszt_rob_txt   += "(faktor_mh_przezbr/100) * koszt_rob_przezbr * przezbrojen "
    koszt_rob_txt   += "+ [(faktor_mh_praca/100) * koszt_rob_1K * naklad] "
    koszt_rob_txt   += "+ [(faktor_mh_aw/100) * koszt_rob_zmiany * zmian] "
    koszt_rob += (fin.faktor_mh_przezbr/100) * w.koszt_przezbr.koszt_rob * przezbrojen
    koszt_rob += (fin.faktor_mh_praca  /100) * koszt_rob_1K *naklad
    koszt_rob += (fin.faktor_mh_aw     /100) * w.koszt_zmiany.koszt_rob * zmian;
    const koszt_produkcji_rob_EUR_= new Licz("koszt_produkcji_robocizna_EUR = "+koszt_rob_txt);
    koszt_produkcji_rob_EUR_.set_x(koszt_rob);
    koszt_produkcji_rob_EUR_.add_det(faktor_mh_przezbr_)
    koszt_produkcji_rob_EUR_.add_det(koszt_rob_przezbr_)
    koszt_produkcji_rob_EUR_.add_det(przezbrojen_)
    koszt_produkcji_rob_EUR_.add_det(faktor_mh_praca_)
    koszt_produkcji_rob_EUR_.add_det(koszt_rob_1K_)
    koszt_produkcji_rob_EUR_.add_det(naklad_)
    koszt_produkcji_rob_EUR_.add_det(koszt_rob_1K_)
    koszt_produkcji_rob_EUR_.add_det(faktor_mh_aw_)
    koszt_produkcji_rob_EUR_.add_det(koszt_rob_zmiany_)
    koszt_produkcji_rob_EUR_.add_det(zmian_)
   
    const koszt_produkcji_EUR_manualny_ = this.calc_koszt_prod_manualny(fin, koszt_transportu, w, przezbrojen, naklad, zmian, n , licz_w_pln, koszt_manualny);
    
    const narzut_manualny_= new Licz("narzut_wyliczony = (koszt_produkcji_EUR - koszt_produkcji_surowiec_EUR) / koszt_produkcji_robocizna_EUR")
    //const narzut_manualny_= new Licz("narzut_wyliczony = ((koszt_produkcji_EUR_manualny * narzut / koszt_produkcji_EUR) -1 )* 100")
    narzut_manualny_.add_det(koszt_produkcji_EUR_manualny_)
    narzut_manualny_.add_det(n_)
    //narzut_manualny_.add_det(koszt_produkcji_EUR_)
    narzut_manualny_.add_det(koszt_produkcji_surowiec_EUR_)
    narzut_manualny_.add_det(koszt_produkcji_rob_EUR_)
    //const nn = (koszt_produkcji_EUR_manualny_.get_x() - koszt_produkcji_surowiec_EUR_.get_x())/ koszt_produkcji_rob_EUR_.get_x();
    //const nn = (koszt_produkcji_EUR_manualny_.get_x() / (koszt_produkcji_surowiec_EUR_.get_x()) + koszt_produkcji_rob_EUR_.get_x());
    //narzut_manualny_.set_x(100*(nn-1));
    narzut_manualny_.set_x(((koszt_produkcji_EUR_manualny_.get_x() * n_.get_x() / koszt_produkcji_EUR_.get_x())-1 )*100);

    //koszt_.add_det(narzut_manualny_);

    //koszt_.set_x(koszt)

    return narzut_manualny_;
   
  }


  private static calc_koszt_prod_manualny(fin:IFin, koszt_transportu:number, w:IWykrojnikRow, przezbrojen:number, naklad:number, zmian:number, narzut_zysku_procent:number, licz_w_pln:boolean, koszt_manualny: number) {

    const naklad_ =  new Wartość("naklad",naklad)

    let dodaj_koszt_transportu=0;
    let faktor_koszt_transportu=1.0;
    if (fin.warunki_dostawy.indexOf("EXW")==-1)    {
      if (koszt_transportu) {
        dodaj_koszt_transportu=koszt_transportu
        faktor_koszt_transportu = 1.0
      } else {
        dodaj_koszt_transportu  = 0
        faktor_koszt_transportu = 1.0;
        if (fin.warunki_dostawy.indexOf("EXW")==-1) faktor_koszt_transportu = 1.0105;
      }
    }

    const dodaj_koszt_transportu_ =  new Wartość("dodaj_koszt_transportu",dodaj_koszt_transportu)
    const faktor_koszt_transportu_ =  new Wartość("faktor_koszt_transportu",faktor_koszt_transportu)
    const dodajKosztProcent_ =  new Wartość("dodajKosztProcent",fin.dodajKosztProcent)
    const rabatProcent_ =  new Wartość("rabatProcent",fin.rabatProcent)
    const dodajKoszt1K_ =  new Wartość("dodajKoszt1K",fin.dodajKoszt1K)
    
    let kurs=1.0
    if (!(fin.waluta_kalkulacji=="EUR") || licz_w_pln) kurs=fin.kurs_euro;
    const kurs_ =  new Wartość("kurs",kurs)

    const kpm_ = new Licz("koszt_produkcji_EUR_manualny = ((koszt_manualny / kurs) * nakład) / ( 1-rabatProcent/100 ) / ( 1+fin.dodajKosztProcent/100  ) / faktor_koszt_transportu - dodaj_koszt_transportu");
    let kpm = 0
    kpm =   koszt_manualny;
    kpm /=  kurs;
    
    kpm *=  naklad;
    kpm /=  ( 1-fin.rabatProcent/100 );
    kpm /=  ( 1+fin.dodajKosztProcent/100  )
    
    kpm /=  faktor_koszt_transportu
    kpm -=  dodaj_koszt_transportu

    const koszt_manualny_ = new Wartość('koszt_manualny', koszt_manualny)
    kpm_.add_det(koszt_manualny_)
    kpm_.add_det(kurs_)
    kpm_.add_det(naklad_)
    kpm_.add_det(dodajKoszt1K_)
    kpm_.add_det( new Wartość("nakład",naklad))
    kpm_.add_det(rabatProcent_)
    kpm_.add_det(dodajKosztProcent_)
    kpm_.add_det(faktor_koszt_transportu_)
    kpm_.add_det(dodaj_koszt_transportu_)
    kpm_.set_x(kpm)
    return kpm_;
  }

}
